<div class="invitation">
    <div class="loading-container">
        <div class="spinner">
            <mat-spinner [diameter]="90"></mat-spinner>
            <span>Loading...</span>
        </div>
    </div>
</div>